import React, {useState} from "react"

import {ChatbotEvent} from "@proto/chatbot/v1alpha/chatbot"
import {useTheme} from "@/hooks/useTheme"
import {useWebsocket} from "@/hooks/useWebsocket"

interface IProps {
    message: string
}

interface SegmentDistanceInput {
    distance: number
    message: string
}

const SegmentDistanceMessage = ({message}: IProps) => {
    const {send, addMessage} = useWebsocket()
    const {BotIcon} = useTheme()
    const [submitted, setSubmitted] = useState(false)

    // Parse the incoming message
    let distanceData: SegmentDistanceInput
    try {
        distanceData = JSON.parse(message)
    } catch (e) {
        console.error("Failed to parse distance data:", e)
        return null
    }

    // Form state
    const [distance, setDistance] = useState(distanceData.distance)

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault()
        if (submitted) return

        // Validate input
        if (distance <= 0 || distance > 1) {
            alert("Distance must be between 0 and 1")
            return
        }

        const distanceResponse = {
            distance: distance,
        }

        // Send the distance to the backend
        const um: ChatbotEvent = {
            type: "user",
            message: JSON.stringify(distanceResponse),
            id: "",
            clientId: "",
        }
        send(JSON.stringify(um))

        // Add a display message for the user
        const displayMessage = `Selected distance: ${distance}`
        const dm: ChatbotEvent = {
            type: "user",
            message: displayMessage,
            id: "",
            clientId: "",
        }
        addMessage(dm)

        setSubmitted(true)
    }

    return (
        <div className="m-[20px] ml-0 mr-0 flex items-start justify-start">
            <div className="mr-[10px]">{BotIcon}</div>
            <div className="min-w-[300px] rounded-2xl rounded-tl-none bg-response p-[20px] pb-[12px] pt-[12px]">
                <p className="mb-4 whitespace-pre-wrap">{distanceData.message}</p>

                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label htmlFor="distance" className="mb-1 block text-sm font-medium">
                            Segment Distance (0.0 - 1.0)
                        </label>
                        <input
                            type="number"
                            id="distance"
                            value={distance}
                            onChange={(e) => setDistance(parseFloat(e.target.value) || 0)}
                            min="0"
                            max="1"
                            step="0.01"
                            disabled={submitted}
                            className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100"
                        />
                        <p className="mt-1 text-xs text-gray-600">Lower values = more similar articles, Higher values = broader match</p>
                    </div>

                    <button
                        type="submit"
                        disabled={submitted}
                        className="w-full rounded-md bg-blue-600 px-4 py-2 text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:cursor-not-allowed disabled:bg-gray-400"
                    >
                        {submitted ? "Submitted" : "Set Distance"}
                    </button>
                </form>
            </div>
        </div>
    )
}

export default SegmentDistanceMessage
